import { useCallback, useSyncExternalStore } from "react";

import {
  getMicPreferences,
  resetMicPreferences,
  setMicPreference,
  subscribeMicPreferences,
  type MicPreferences,
} from "@/lib/audio/micPreferences";

export function useMicPreferences(): {
  preferences: MicPreferences;
  set: <K extends keyof MicPreferences>(key: K, value: MicPreferences[K]) => void;
  reset: () => void;
} {
  const preferences = useSyncExternalStore(subscribeMicPreferences, getMicPreferences);

  const set = useCallback(<K extends keyof MicPreferences>(key: K, value: MicPreferences[K]) => {
    setMicPreference(key, value);
  }, []);

  const reset = useCallback(() => {
    resetMicPreferences();
  }, []);

  return { preferences, set, reset };
}
